import styled from 'styled-components';

// 버튼1 타입
// width: auto | height: 34px | font-size: 16px
export const Btn1Type = styled.button`
  height: 34px;
  box-sizing: border-box;
  padding: 0 18px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
`;
// color: #fff | background-color: #4880FF
export const Btn1Type1 = styled(Btn1Type)`
  color: #fff;
  background-color: ${(props) => props.theme.mainColor1};
`;
// color: #fff | background-color: #FF6853
export const Btn1Type2 = styled(Btn1Type)`
  color: #fff;
  background-color: ${(props) => props.theme.subColor1};
`;
// color: #fff | background-color: #292E42
export const Btn1Type3 = styled(Btn1Type)`
  color: #fff;
  background-color: ${(props) => props.theme.subColor2};
`;
// color: #fff | background-color: #3BAEDC
export const Btn1Type4 = styled(Btn1Type)`
  color: #fff;
  background-color: ${(props) => props.theme.mainColor3};
`;
// color: #fff | background-color: #117C44
export const Btn1Type5 = styled(Btn1Type)`
  color: #fff;
  background-color: ${(props) => props.theme.subColor4};
`;

// 버튼2 타입
// width: 77px | height: 34px | font-size: 16px
export const Btn2Type = styled.button`
  width: 77px;
  height: 34px;
  box-sizing: border-box;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
`;
// color: #fff | background-color: #4880FF
export const Btn2Type1 = styled(Btn2Type)`
  color: #fff;
  background-color: ${(props) => props.theme.mainColor1};
`;
// color: #fff | background-color: #FF6853
export const Btn2Type2 = styled(Btn2Type)`
  color: #fff;
  background-color: ${(props) => props.theme.subColor1};
`;
// color: #fff | background-color: #292E42
export const Btn2Type3 = styled(Btn2Type)`
  color: #fff;
  background-color: ${(props) => props.theme.subColor2};
`;
// color: #fff | background-color: #3BAEDC
export const Btn2Type4 = styled(Btn2Type)`
  color: #fff;
  background-color: ${(props) => props.theme.mainColor3};
`;

// 버튼3 타입
// width: auto | height: 34px | font-size: 15px
export const Btn3Type = styled.button`
  height: 34px;
  box-sizing: border-box;
  padding: 0 18px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 500;
`;
// color: #fff | background-color: #4880FF
export const Btn3Type1 = styled(Btn3Type)`
  color: #fff;
  background-color: ${(props) => props.theme.mainColor1};
`;
// color: #fff | background-color: #FF6853
export const Btn3Type2 = styled(Btn3Type)`
  color: #fff;
  background-color: ${(props) => props.theme.subColor1};
`;
// color: #fff | background-color: #292E42
export const Btn3Type3 = styled(Btn3Type)`
  color: #fff;
  background-color: ${(props) => props.theme.subColor2};
`;
// color: #fff | background-color: #3BAEDC
export const Btn3Type4 = styled(Btn3Type)`
  color: #fff;
  background-color: ${(props) => props.theme.mainColor3};
`;

// 버튼4 타입
// width: 96px | height: 36px | font-size: 14px
export const Btn4Type = styled.button`
  width: 96px;
  height: 36px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
`;
// color: #fff | background-color: #4880FF
export const Btn4Type1 = styled(Btn4Type)`
  color: #fff;
  background-color: ${(props) => props.theme.mainColor1};
`;
// color: #fff | background-color: #FF6853
export const Btn4Type2 = styled(Btn4Type)`
  color: #fff;
  background-color: ${(props) => props.theme.subColor1};
`;
// color: #fff | background-color: #292E42
export const Btn4Type3 = styled(Btn4Type)`
  color: #fff;
  background-color: ${(props) => props.theme.subColor2};
`;
// color: #fff | background-color: #3BAEDC
export const Btn4Type4 = styled(Btn4Type)`
  color: #fff;
  background-color: ${(props) => props.theme.mainColor3};
`;

const BS = {
  Btn1Type1,
  Btn1Type2,
  Btn1Type3,
  Btn1Type4,
  Btn1Type5,
  Btn2Type1,
  Btn2Type2,
  Btn2Type3,
  Btn2Type4,
  Btn3Type1,
  Btn3Type2,
  Btn3Type3,
  Btn3Type4,
  Btn4Type1,
  Btn4Type2,
  Btn4Type3,
  Btn4Type4,
};

export default BS;
